import createIcon from '../../createIcon';

/**
 * @component @name FormatStrikethrough
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTkuNUgxNFYxNi41SDEwVjE5LjVaTTUgNC41VjcuNUgxMFYxMC41SDE0VjcuNUgxOVY0LjVINVpNMyAxNC41SDIxVjEyLjVIM1YxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatStrikethrough = createIcon('FormatStrikethrough', [
  [
    'path',
    {
      d: 'M10 19.5H14V16.5H10V19.5ZM5 4.5V7.5H10V10.5H14V7.5H19V4.5H5ZM3 14.5H21V12.5H3V14.5Z',
      key: 'npl44n',
    },
  ],
]);

export default FormatStrikethrough;
